import { render, staticRenderFns } from "./ImportForm.vue?vue&type=template&id=19ec9e18&scoped=true"
import script from "./ImportForm.vue?vue&type=script&lang=js"
export * from "./ImportForm.vue?vue&type=script&lang=js"
import style0 from "./ImportForm.vue?vue&type=style&index=0&id=19ec9e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec9e18",
  null
  
)

export default component.exports